
export const errorsClear = () => {
  return {
    type: "ERRORS_CLEAR",
  }
}
